import * as GTagOptIn from 'gtag-opt-in';

const analytics = {
  id: 'G-00T4KF4DF6',
  registered: false,
  enabled: false,
  cookie: {
    name: 'CookieConsent',
    duration: 20,
  },

  init() {
    // Check if consent was previously given
    const consentState = this.getConsentCookie();
    
    if (consentState === true) {
      // Re-enable analytics if consent was previously given
      this.setOptInState(true);
    } else if (consentState !== true) {
      this.clearTrackingCookies();
    }
  },
  
  register() {
    console.log('Registering GTagOptIn...');
    GTagOptIn.register(this.id);
    this.registered = true;
  },
  
  setOptInState(state) {
    // Always register if not already registered
    if (!this.registered) {
      this.register();
    }

    console.log('Opt-in state:', state);
    
    if (state) {
      // Ensure window property is properly set before accessing
      window['ga-disable-' + this.id] = false;
      GTagOptIn.optIn();
      this.enabled = true;
    } else {
      GTagOptIn.optOut();
      window['ga-disable-' + this.id] = true;
      this.enabled = false;
    }
    
    this.setConsentCookie(state);
  },
  
  getOptInState() {
    return this.enabled;
  },

  getConsentCookie() {
    var i, x, y, ARRcookies = document.cookie.split(';');
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === this.cookie.name) {
        return JSON.parse(y);
      }
    }
    return -1;
  },
  
  setConsentCookie(state) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + this.cookie.duration);
    var c_value = escape(state) + '; expires=' + exdate.toUTCString() + '; path=/';
    document.cookie = this.cookie.name + '=' + c_value;
  },
  
  clearTrackingCookies() {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf('_ga') > -1) {
        const cookie = cookies[i].split('=');
        document.cookie = cookie[0].trim() + '=0; Max-Age=-99999999; path=/;';
      }
    }
  },

  // Updated to include pageTitle and screenClass parameters
  trackRoute(route, pageTitle, screenClass) {
    if (!this.enabled || !window.gtag) {
      console.log('Analytics tracking disabled or gtag not available');
      return;
    }
    
    // Use provided title or default to route
    const title = pageTitle || route;
    
    console.log(`Tracking page view: ${title}, screen class: ${screenClass || 'none'}`);
    
    window.gtag('js', new Date());
    window.gtag('config', this.id, {
      'page_title': title,
      'page_location': window.location.href,
      'page_path': route,
      'screen_class': screenClass || ''  // Include screen class parameter
    });
  },
  
  trackEvent(route, name, target) {
    const element = target.hasAttribute('data-category')
      ? target
      : target.parentElement;
      
    if (!element) {
      console.warn('Could not find element with data attributes for tracking');
      return;
    }
    
    this.trackGoal(
      route,
      element.getAttribute('data-event') + ' ' + element.getAttribute('data-category'),
      element.getAttribute('data-event'),
    );
  },
  
  trackGoal(route, title, event) {
    if (!this.enabled || !window.gtag) {
      return;
    }
    
    window.gtag('event', event || 'view', {
      'event_category': 'user_engagement',
      'event_label': title,
      'page_title': route + '#' + title,
      'page_location': window.location.href,
      'page_path': route
    });
  }
};

export default analytics;